import { Drawer } from "antd";
import Lottie from "lottie-react";
import loading from "../../assets/assets/json/loading.json";
import "./loading.css";
const Loading = (props) => {
  const { enableLoading } = props;
  return (
    <Drawer
      className="background-transparent"
      visible={enableLoading}
      closable={false}
      placement="top"
      width="100%"
      height="100%"
      size="large"
    >
      <div className="loading-div">
        <Lottie animationData={loading} style={{ marginTop: "-10px" }} />
      </div>
    </Drawer>
  );
};
export default Loading;
